module.exports = __webpack_public_path__ + "static/media/sort_desc_disabled.8463fd96.png";